<template>
<div>
    <iframe id="analytics-iframe" v-if="iframeAllowed" :src="iframeUrl" width="100%" height="1800" frameborder="0"></iframe>
    <div v-else>
        This page cannot be embedded due to security restrictions.
    </div>
</div>
</template>

  
<script>
export default {
    data() {
        return {
            iframeUrl: 'https://tmisodc.org/analytics/index',
            iframeAllowed: false
        };
    },
    mounted() {
        const basePath = process.env.VUE_APP_BASE_PATH;
        if (basePath.includes("dev.tmisodc.org")) {
            this.iframeUrl = `https://dev.tmisodc.org/analytics/index`;
        } else {
            this.iframeUrl = `https://tmisodc.org/analytics/index`;
        }

        this.iframeAllowed = true;
        // Optionally, you could detect if the iframe is blocked using a try-catch, though it’s limited
        setTimeout(() => {
            const iframe = document.querySelector('iframe');
            if (iframe && iframe.contentWindow === null) {
                this.iframeAllowed = false;
            }
        }, 1000);
        window.addEventListener('message', (event) => {
            // Optional: check event.origin === 'https://dev.tmisodc.org'
            const {
                type,
                href
            } = event.data;
            if (type === 'urlChange') {
                console.log('Iframe URL:', href);
                const iframe = document.getElementById('analytics-iframe');
                if (href.includes('organizational-performance')) {
                    iframe.setAttribute('height', '1500');
                }
                if (href.includes('impact-analysis')) {
                    iframe.setAttribute('height', '2500');
                }
                if (href.includes('engagement-analysis')) {
                    iframe.setAttribute('height', '1700');
                }
                if (href.includes('facilitator-analysis')) {
                    iframe.setAttribute('height', '2500');
                }
            }
        });
    }
};
</script>
